/**
 * @generated SignedSource<<bf070103bf2ce6f8f65a1cb16e161354>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ScreenersRespondentMasterStatusChoices = "A" | "CS" | "D" | "IW" | "NR" | "NS" | "OQ" | "RT" | "RW" | "S" | "SS" | "T" | "%future added value";
export type DenyRespondentInput = {
  clientMutationId?: string | null;
  respondentId: string;
  studyId: string;
};
export type ScheduleCell_denyRespondent_Mutation$variables = {
  input: DenyRespondentInput;
};
export type ScheduleCell_denyRespondent_Mutation$data = {
  readonly denyRespondent: {
    readonly respondent: {
      readonly id: string;
      readonly masterStatus: ScreenersRespondentMasterStatusChoices | null;
    } | null;
    readonly study: {
      readonly approvedTabCount: number | null;
      readonly needsReviewCount: number | null;
      readonly rejectedCount: number | null;
      readonly scheduledCount: number | null;
    } | null;
  } | null;
};
export type ScheduleCell_denyRespondent_Mutation = {
  response: ScheduleCell_denyRespondent_Mutation$data;
  variables: ScheduleCell_denyRespondent_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "RespondentNode",
  "kind": "LinkedField",
  "name": "respondent",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "masterStatus",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approvedTabCount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scheduledCount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "needsReviewCount",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rejectedCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ScheduleCell_denyRespondent_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DenyRespondentPayload",
        "kind": "LinkedField",
        "name": "denyRespondent",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StudyNode",
            "kind": "LinkedField",
            "name": "study",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ScheduleCell_denyRespondent_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DenyRespondentPayload",
        "kind": "LinkedField",
        "name": "denyRespondent",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StudyNode",
            "kind": "LinkedField",
            "name": "study",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bb3b18918de71180b945283672a3e86e",
    "id": null,
    "metadata": {},
    "name": "ScheduleCell_denyRespondent_Mutation",
    "operationKind": "mutation",
    "text": "mutation ScheduleCell_denyRespondent_Mutation(\n  $input: DenyRespondentInput!\n) {\n  denyRespondent(input: $input) {\n    respondent {\n      id\n      masterStatus\n    }\n    study {\n      approvedTabCount\n      scheduledCount\n      needsReviewCount\n      rejectedCount\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "acf3e839b5fc2c38fd219f9c5681e82f";

export default node;
